import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { SubmitState, EMAIL_VALIDATOR, createSubmitStateEffect } from './common'

import './contact.scss'

const ContactForm = () => {
  const { register, errors, reset, handleSubmit } = useForm()
  const [submitButtonText, setSubmitButtonText] = useState('Send message')
  const [submitState, setSubmitState] = useState(SubmitState.NOT_SUBMITTED)
  const [inError, setInError] = useState(false)

  const validate = errors =>
    !(errors.name || errors.email || errors.questionOrComment)
    
  const onSubmit = data => {
    setSubmitState(SubmitState.SUBMITTING)
    let formData = new FormData()
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value)
    })
    formData.append('formDataNameOrder', JSON.stringify(Object.keys(data)))
    fetch(process.env.GATSBY_CONTACT_FORM_URL, {
      method: 'POST',
      body: formData,
    })
      .then(res => {
        if (res.status === 200) {
          setSubmitState(SubmitState.SUBMITTED)
        }
      })
      .catch(err => {
        console.log('Apps Script error: ' + err)
      })
  }

  useEffect(() => {
    const isValid = validate(errors)
    setInError(!isValid)
  }, [errors])

  useEffect(
    createSubmitStateEffect({
      submitState,
      setSubmitButtonText,
      reset,
      setSubmitState,
      defaultButtonText: 'Send message',
    }),
    [submitState]
  )

  return (
    <div>
      <div className="body margin-bottom-large">
        Want to join or learn more about Lead to Read KC? We look forward to
        connecting with you.
      </div>
      <form
        name="contact"
        className="contact"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="label-and-error">
          <label
            className={`body bold no-margin ${errors.name ? 'error-text' : ''}`}
            htmlFor="name"
          >
            Name*
          </label>
          <input
            placeholder={`${errors.name ? 'Required' : ''}`}
            id="name"
            name="name"
            ref={register({ required: true })}
            className="contact-input"
          />
        </div>
        <div className="label-and-error">
          <label
            className={`body bold no-margin ${
              errors.email ? 'error-text' : ''
            }`}
            htmlFor="email"
          >
            Email*
          </label>
          <input
            placeholder={`${errors.email ? 'Required' : ''}`}
            id="email"
            name="email"
            ref={register(EMAIL_VALIDATOR)}
            className="contact-input"
          />
        </div>
        <div className="label-and-error">
          <label
            className={`body bold no-margin ${
              errors.questionOrComment ? 'error-text' : ''
            }`}
            htmlFor="questionOrComment"
          >
            Question or comment*
          </label>
        </div>
        <textarea
          id="message"
          name="message"
          className={`contact-input body ${errors.message ? 'error-text' : ''}`}
          ref={register({ required: true })}
        />
        {inError && (
          <div className="error-text italic margin-bottom-medium">
            Please fill out required fields
          </div>
        )}
        <button
          className="body button"
          type="submit"
          disabled={!validate(errors)}
        >
          {submitButtonText}
        </button>
      </form>
      {inError && <p>Something went wrong. Please try again later.</p>}
      {submitState === SubmitState.SUBMITTED && (
        <p>Thanks for the submission!</p>
      )}
    </div>
  )
}

export default ContactForm
